
<ng-container *ngIf="isLoaded">
  <div class="modal-close-btn" (click)="closeModal()">X</div>
  <div class="card mb-3">
    <div class="card-body">
      <div class="pt-4 pb-2">
        <h5 class="card-title text-center pb-0 fs-4">Редакция на Документ Към Услуга</h5>
        <p class="text-center small">Моля, въведете необходимите Данни</p>
      </div>

      <form [formGroup]="Form" class="row g-3 needs-validation" (ngSubmit)="onSubmit()">
        <div class="col-12">
          <label for="documentLinkType" class="form-label">Избери Документ</label>
          <select #selectElem  class="form-select" (change)="onDocumentChange(selectElem.value)">
            <option value="-1" selected="selected">Изберете Документ</option>
            <ng-container *ngFor="let doc of documents">

              <option *ngIf="isSelected(doc)" selected="selected" [value]="doc.idDocument">
                {{trimTitle(doc.title)}}
              </option>

              <option *ngIf="!isSelected(doc)" [value]="doc.idDocument">
                {{trimTitle(doc.title)}}
              </option>
            </ng-container>

          </select>
        </div>
        <div class="col-12">
          <label for="order" class="form-label">Поредност</label>
          <input type="text" formControlName="order" class="form-control" id="order">
        </div>
        <div class="col-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="isRequired" id="isRequired">
            <label class="form-check-label" for="isRequired">Задължителен</label>
          </div>
        </div>
        <div class="col-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="isDownloadable" id="isDownloadable">
            <label class="form-check-label" for="isDownloadable">Документ за попълване</label>
          </div>
        </div>
        <div class="col-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="isActive" id="isActive">
            <label class="form-check-label" for="isActive">Активен</label>
          </div>
        </div>
        <div class="col-12">
          <button class="btn btn-primary w-100" type="submit" [disabled]="!Form.valid">Редактирай</button>
        </div>
      </form>
    </div>
  </div>

</ng-container>
